import { z } from 'zod'

import { emailField } from '@maestro/commerce-blocks/schemas/fields'

export const outOfStockNotificationFormSchema = z.object({
  email: emailField,
})
